/* global HSCore */
/* global bootstrap */

import React, { useContext, useEffect, useRef } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import moment from "moment";
import BgProfile from "../../../images/Union.svg";
import EditIcon from "../../svg/Edit";
import axiosInstance from "../../../utils/Requests/axios";
import UserContext from "../../../utils/Contexts/UserContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import toast from "react-hot-toast";

function BasicInfo({
  formValues,
  setFormValues,
  image,
  memberSince,
  formLoaded,
}) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(URL.createObjectURL(file));
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Handle PUT request (Send only changed values)
  const handleSaveChanges = () => {
    if (!userData?.uuid) return;

    axiosInstance
      .put(`settings/users/${userData.uuid}/profile`, formValues)
      .then(() => {
        toast.success(t("Profile updated!"));
      })
      .catch(() => {
        toast.error(t("Error updating profile!"));
      });
  };

  const hsInitRef = useRef(false);
  useEffect(() => {
    if (formLoaded && !hsInitRef.current) {
      HSCore.components.HSTomSelect.init(".js-select-privacy");
      hsInitRef.current = true;
    }
  }, [formLoaded]);

  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, []);

  const localizeDate = (date) => {
    const localizedDateText = moment(date).format("MMM DD, YYYY");

    const mappings = {
      Jan: t("Jan"),
      Feb: t("Feb"),
      Mar: t("Mar"),
      Apr: t("Apr"),
      May: t("May"),
      Jun: t("Jun"),
      Jul: t("Jul"),
      Aug: t("Aug"),
      Sep: t("Sep"),
      Oct: t("Oct"),
      Nov: t("Nov"),
      Dec: t("Dec"),
    };

    return localizedDateText
      .split(" ")
      .map((word) => mappings[word] || word)
      .join(" ");
  };

  return (
    <div id="BasicInfo" className={`${themeStatus?.[selectedTheme]}`}>
      <div
        className="py-9 position-relative"
        style={{
          borderTopLeftRadius: "0.7rem",
          borderTopRightRadius: "0.7rem",
          backgroundColor: "var(--border)",
          backgroundImage: `url(${BgProfile})`,
        }}
      >
        <div
          className="position-absolute translate-middle-y"
          style={{ top: "95%", left: "25px", zIndex: 99 }}
        >
          <div className="position-relative d-inline-block">
            <img
              src={image}
              alt="Profile"
              className="rounded-circle"
              width="160"
              height="160"
              style={{ border: "2px solid var(--border)", objectFit: "cover" }}
            />
            <label
              htmlFor="imageUpload"
              className="position-absolute text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "34px",
                height: "34px",
                bottom: "5px",
                right: "0px",
                cursor: "pointer",
                background: "var(--border)",
              }}
            >
              <EditIcon size={18} />
            </label>

            <input
              type="file"
              id="imageUpload"
              accept="image/*"
              className="d-none"
              // onChange={handleImageUpload}
            />
          </div>
        </div>
        <div
          className="position-absolute text-white pe-4 member-text"
          style={{
            bottom: "10px",
            right: "0",
            zIndex: "1",
          }}
        >
          Member since {localizeDate(memberSince)}
        </div>
      </div>

      <div
        style={{ borderTopLeftRadius: "unset", borderTopRightRadius: "unset" }}
        className="card cardSetting"
      >
        <div className="card-header">
          <h4
            className="card-title"
            style={{ fontWeight: "700", paddingTop: "5rem" }}
          >
            {t("Basic Information")}
          </h4>
        </div>

        <div className="card-body">
          <div className="d-flex account-setting-responsiveness w-100">
            <label
              className="form-label card-text"
              style={{ color: "var(--whiteToBlack)" }}
            >
              {t("Who Can See Your Profile Photo")}?
              <i
                className="bi-question-circle text-secondary ps-3"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={t("Who Can See Your Profile Photo")}
              />
            </label>

            <div className="tom-select-custom profile-visibility-select">
              <select
                className="js-select-privacy form-select form-select-sm card-text"
                autoComplete="off"
                data-hs-tom-select-options='{
                      "placeholder": "Select Access Type",
                      "hideSearch": true
                    }'
                value={formValues.visibility}
                onChange={handleInputChange}
                name="visibility"
              >
                <option value={0}>{t("Anyone")}</option>
                <option value={1}>{t("Only Me")}</option>
              </select>
            </div>
          </div>

          <div className="d-flex account-setting-responsiveness w-100 mt-3">
            <label
              className="form-label card-text"
              style={{ color: "var(--whiteToBlack)" }}
            >
              {t("Full Name")}
              <i
                className="bi-question-circle text-secondary ps-3"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={t("Full Name")}
              />
            </label>
            <div className="d-flex gap-2 profile-visibility-select">
              <div className="w-50">
                <input
                  type="text"
                  className="form-control account-placeholder rounded-2 "
                  placeholder={t("First Name")}
                  name="first_name"
                  value={formValues.first_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-50">
                <input
                  type="text"
                  className="form-control account-placeholder rounded-2"
                  placeholder={t("Last Name")}
                  name="last_name"
                  value={formValues.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="d-flex account-setting-responsiveness w-100 mt-3">
            <label
              className="form-label card-text"
              style={{ color: "var(--whiteToBlack)" }}
            >
              {t("Phone")}{" "}
              <span
                className="responsive-text"
                style={{ color: "var(--gray)" }}
              >
                (optional)
              </span>
            </label>
            <div className="profile-visibility-select">
              <input
                type="text"
                className="form-control account-placeholder rounded-2 "
                placeholder={t("Phone")}
                name="phone_number"
                value={formValues.phone_number}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <div className="card-header p-0"></div>
        <div className="d-flex justify-content-end card-body pt-3">
          <button
            className="btn btn-primary edit-profile-btn p-0"
            onClick={handleSaveChanges}
          >
            {t("Save Changes")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BasicInfo;
